// this is used as a key for the form values for consistency
const FORM_KEYS = {
  gradeLevel: 'gradeLevel',
  subject: 'subject',
  language: 'language',
  lessonFormat: 'lessonFormat',
  objective: 'objective',
  objective2: 'objective2',
  objective3: 'objective3',
  objective4: 'objective4',
  time: 'time',
  modality: 'modality',
  // for AmericanLP
  curriculumFramework: 'curriculumFramework',
  specificStandards: 'specificStandards',
  strategies: 'strategies',
  // for MontessoriLP
  title: 'title',
  classProgram: 'classProgram',
  materials: 'materials',
  prerequisites: 'prerequisites',
  keyArea: 'keyArea',
  keyArea2: 'keyArea2',
  keyArea3: 'keyArea3',
};

export default FORM_KEYS;
